import { useSelector,useDispatch } from "react-redux";
import { useEffect,useState } from "react";
import { ErrorToastContainer } from "../whatsapp/function/CustomFunction";
import BlankLoader from "../CommerceManager/component/BlankLoader";
import domain from "../reusecomponent/domain";
import { update } from "../redux/gmbDashboardSlice";

export default function Dashboard(){
  const dashboardData = useSelector((state) => state.gmbDashboardStore.value);
  const Accesstoken = useSelector((state) => state.Token.value);
  const [loading,setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(()=>{
    if(dashboardData) return;
    fetchData();
  },[]);
  
  let fetchData = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${domain()}/gmb/dashboard`, {
        headers: { Authorization: `Bearer ${Accesstoken}` },
      });

      const json = await res.json();
      if (res.ok && json.status){
        dispatch(update(json.data));
      }else{
        ErrorToastContainer(json.message);
      }
    } catch {
      ErrorToastContainer("Internal Server Problem");
    } finally {
      setLoading(false);
    }
  }

  const monthColors = [
    "bg-primary",
    "bg-danger",
    "bg-success",
    "bg-warning",
    "bg-info",
    "bg-secondary",
  ];

  return (
      <div className="commerce_status-card">
        {loading && (
          <BlankLoader/>
        )}
        <div className="card-body py-4">

          {/* ===== TOP STATS ===== */}
          <div className="row g-3">

            <div className="col-xl-3 col-md-6">
              <div className="card border-0 shadow-sm text-center">
                <div className="card-body">
                  <h6 className="text-muted">Total Reviews</h6>
                  <h2 className="fw-bold text-primary">{dashboardData?.total_reviews ?? 0}</h2>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-md-6">
              <div className="card border-0 shadow-sm text-center">
                <div className="card-body">
                  <h6 className="text-muted">Replied Reviews</h6>
                  <h2 className="fw-bold text-success">{dashboardData?.replied_reviews ?? 0}</h2>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-md-6">
              <div className="card border-0 shadow-sm text-center">
                <div className="card-body">
                  <h6 className="text-muted">Average Rating</h6>
                  <h2 className="fw-bold text-warning">
                    {dashboardData?.average_rating ?? 0} <span className="fs-5">★</span>
                  </h2>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-md-6">
              <div className="card border-0 shadow-sm text-center">
                <div className="card-body">
                  <h6 className="text-muted">Pending Replies</h6>
                  <h2 className="fw-bold text-danger">{dashboardData?.pending_replies ?? 0}</h2>
                </div>
              </div>
            </div>

          </div>

          {/* ===== BUSINESS & QR STATS ===== */}
          <div className="row g-3 mt-2">

            <div className="col-md-4">
              <div className="card border-0 shadow-sm text-center">
                <div className="card-body">
                  <h6 className="text-muted">Total QR Generated</h6>
                  <h2 className="fw-bold text-info">0</h2>
                  <small className="text-muted">Via Get Review</small>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card border-0 shadow-sm text-center">
                <div className="card-body">
                  <h6 className="text-muted">Businesses Added</h6>
                  <h2 className="fw-bold text-dark">{dashboardData?.businesses_added ?? 0}</h2>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card border-0 shadow-sm text-center">
                <div className="card-body">
                  <h6 className="text-muted">Automated Businesses</h6>
                  <h2 className="fw-bold text-success">{dashboardData?.automated_businesses ?? 0}</h2>
                </div>
              </div>
            </div>

          </div>

          {/* ===== REPORTS SECTION ===== */}
          <div className="row mt-4 g-3">

            {/* Weekly Report */}
            <div className="col-lg-4">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-header bg-white border-0">
                  <h6 className="fw-semibold mb-0">Weekly Review Report</h6>
                </div>
                <div className="card-body">
                  <label className="small">Reviews Growth</label>
                  <div className="progress mb-2">
                    <div className="progress-bar bg-success" style={{width: `${dashboardData?.weekly?.reviews ?? 0}%`}}>
                      {dashboardData?.weekly?.reviews ?? 0}%
                    </div>
                  </div>

                  <label className="small">Replies Completed</label>
                  <div className="progress">
                    <div className="progress-bar bg-primary" style={{width: `${dashboardData?.weekly?.replied ?? 0}%`}}>
                      {dashboardData?.weekly?.replied ?? 0}%
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Monthly Report */}
            <div className="col-lg-4">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-header bg-white border-0">
                  <h6 className="fw-semibold mb-0">Monthly Review Report</h6>
                </div>
                <div className="card-body">
                  <label className="small">New Reviews</label>
                  <div className="progress mb-2">
                    <div className="progress-bar bg-warning" style={{width: `${dashboardData?.monthly?.reviews ?? 0}%`}}>
                      {dashboardData?.monthly?.reviews ?? 0}%
                    </div>
                  </div>

                  <label className="small">Automation Usage</label>
                  <div className="progress">
                    <div className="progress-bar bg-info" style={{width: `${dashboardData?.monthly?.automation_usage ?? 0}%`}}>
                      {dashboardData?.monthly?.automation_usage ?? 0}%
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 6 Months Report */}
            <div className="col-lg-4">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-header bg-white border-0">
                  <h6 className="fw-semibold mb-0">Last 6 Months Growth</h6>
                </div>
                <div className="card-body">
                  {dashboardData?.growth && dashboardData?.growth.length ? (
                    dashboardData?.growth.map((data,index) => {
                      return(
                        <div className="mb-2" key={index}>
                          <small>{data?.month}</small>
                          <div className="progress">
                              <div
                                className={`progress-bar bg-primary ${monthColors[index % monthColors.length]}`}
                                style={{ width: `${data?.count}%` }}
                              ></div>
                          </div>
                        </div>
                      );
                    })
                  ):(
                    <div className="mb-2 text-center">
                      Report Not Generated
                    </div>
                  )}
                </div>
              </div>
            </div>

          </div>

          {/* ===== LATEST REVIEWS ===== */}
          <div className="row mt-4">
            <div className="col-12">
              <div className="card border-0 shadow-sm">
                <div className="card-header bg-white border-0">
                  <h5 className="fw-semibold mb-0">Latest Reviews</h5>
                </div>
                <div className="card-body p-0">
                  <ul className="list-group list-group-flush">
                      {
                        dashboardData?.latest_reviews && dashboardData?.latest_reviews.length ? (
                          dashboardData?.latest_reviews.map((review,index) => {
                            return (
                              <li className="list-group-item d-flex justify-content-between" key={index}>
                                <div>
                                  <strong>{review.name}</strong>
                                  <div className="text-warning small">★★★★★</div>
                                  <small className="text-muted">
                                    {review.comment}
                                  </small>
                                </div>
                                {review.reviews_replay === 'Replied' ? (
                                  <span className="badge bg-success align-self-start">Replied</span>
                                ):(
                                  <span className="badge bg-danger align-self-start">Pending</span>
                                )}
                           
                              </li>
                            );
                          })
     
                        ) : (
                          <li className="list-group-item d-flex justify-content-between">
                            <div className="text-center w-100">
                              <small className="text-muted">
                                No Records Found. 
                              </small>
                            </div>
                          </li>
                        )
                      }
                  </ul>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
  );
};